export default __webpack_public_path__ + "static/media/mute-icon.abc2ca9c.svg";